import React from 'react';

export const lineSpacing = () => <div style={{ marginTop: '2vh', height: '40px' }} />;
